import cake1 from '../images/cake1.jpg';
import cake2 from '../images/cake2.jpg';
import cake3 from '../images/cake3.jpg';
import coffee1 from '../images/coffee1.jpg';
import coffee2 from '../images/coffee2.jpg';
import coffee3 from '../images/coffee3.jpg';

export const cakes = [
	{
		img: cake1,
		alt: 'Cake',
		title: 'Puddle of love',
		desc: 'Whole orange pistachio cake with dark chocolate smoked salt ganache, toasted buckwheat honey, fresh cherry, and rose buttercream, bourbon rhubarb candy, charcoal, garden blooms. anthropomorphic love horns nestling over gushing sweetness ',
		price: '$15.00',
		button: 'Select',
	},
	{
		img: cake2,
		alt: 'Cake',
		title: 'Orange oceans on biomorphism',
		desc: 'mini vegan golden vanilla bean cake with inspiration drawn from biomorphism. three layers with ume strawberry jam and fresh vanilla coconut cream , cased in a cherry vanilla buttercream.',
		price: '$15.00',
		button: 'Select',
	},
	{
		img: cake3,
		alt: 'Cake',
		title: 'Passage into bloom ',
		desc: 'Grapefruit black sesame marble cake with lavender earl grey infused milk cream, with orange thyme and lavender blooms topped with carrot and chioggia candy, vanilla bourbon rhubarb nasturtium.',
		price: '$15.00',
		button: 'Select',
	},
];

export const coffees = [
	{
		img: coffee1,
		alt: 'Coffee',
		title: 'Espresso',
		desc: 'A Double shot of espresso',
		price: '$3.00',
		button: 'Select',
	},
	{
		img: coffee2,
		alt: 'Coffee',
		title: 'Latte',
		desc: 'Double shot of espresso and 10oz of foamed milk.',
		price: '$5.00',
		button: 'Select',
	},
	{
		img: coffee3,
		alt: 'Coffee',
		title: 'Cold Brew',
		desc: 'Cold coffee brewed overnight using the toddy method.',
		price: '$6.00',
		button: 'Select',
	},
];